var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditsjobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 3.01632V2.50681C0.46875 1.79349 0.46875 1.43683 0.591582 1.16424C0.699763 0.924129 0.871615 0.729876 1.08403 0.607593C1.32519 0.46875 1.64072 0.46875 2.27178 0.46875H8.80777C9.43883 0.46875 9.75436 0.46875 9.99496 0.607593C10.2074 0.729876 10.3798 0.924129 10.488 1.16424C10.6108 1.43619 10.6108 1.79285 10.6108 2.5049V3.01632M0.46875 3.01632H10.6108M0.46875 3.01632V7.3472C0.46875 8.06052 0.46875 8.41718 0.591582 8.68977C0.699619 8.92944 0.872005 9.12429 1.08403 9.24641C1.32463 9.38525 1.64016 9.38525 2.27009 9.38525H8.80946C9.4394 9.38525 9.75436 9.38525 9.99496 9.24641C10.2074 9.12413 10.3798 8.92924 10.488 8.68977C10.6108 8.41718 10.6108 8.06179 10.6108 7.34974V3.01632M2.15909 6.83768H4.41288",
    stroke: "#2463EB",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsjobs);
export default __webpack_public_path__ + "static/media/credits jobs.ee3ee816afb580fe4af4ca576975ae12.svg";
export { ForwardRef as ReactComponent };